module.exports = __webpack_public_path__ + "img/sidebar-icon-admin-setting.12b0b6bd.svg";